import type {
  ApiCollectionResponse,
  ApiPaginatedResponse,
  BrandProductsPayload,
  MarketplaceHomePayload,
  Product
} from "../types/marketplace";
import { get } from "./api";
import { endpoints } from "./endpoints";

export const getMarketplaceHome = async (): Promise<MarketplaceHomePayload> =>
  get<MarketplaceHomePayload>(endpoints.marketplace.home, { includeClientId: false });

export const getProducts = async (
  page = 1,
  perPage = 50
): Promise<ApiPaginatedResponse<Product>> =>
  get<ApiPaginatedResponse<Product>>(endpoints.marketplace.products, {
    includeClientId: false,
    params: {
      page,
      per_page: perPage
    }
  });

export const getBrandProducts = async (
  clientId: number,
  page = 1,
  perPage = 50,
  category?: string
): Promise<BrandProductsPayload> =>
  get<BrandProductsPayload>(endpoints.marketplace.brandProducts(clientId), {
    includeClientId: false,
    params: {
      category,
      page,
      per_page: perPage
    }
  });

export const searchProducts = async (
  value: string
): Promise<ApiCollectionResponse<Product>> =>
  get<ApiCollectionResponse<Product>>(endpoints.marketplace.search(value), {
    includeClientId: false,
    params: {
      limit: 12
    }
  });
